/* eslint-disable
    func-names,
*/
const deps = ['Api'];
const factory = function (Api) {
  class FdsApi extends Api {
    constructor() {
      super('fds');
    }
  }

  return new FdsApi();
};

factory.$inject = deps;
module.exports = factory;
